/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-12-01 16:54:11
 * @FilePath: \sea-page-game\src\views\index\index.js
 */
import Vue from "vue";
import Tpl from "./template.vue";
import Toast from "../../components/toast";
import Base from "../../utils/base";
import Report from "../../utils/report";
import generalMethod from "../../utils/generalMethod";
import SyModel from "../../models/sy";
import Storage from "../../utils/storage";
import Ciphertext from "../../utils/Ciphertext";
import VueI18n from "vue-i18n";

import "../../assets/style/main.scss";
import "../../registerServiceWorker";

Vue.prototype.$Toast = Toast;
Vue.prototype.$Base = Base;
Vue.prototype.$Report = Report;
Vue.prototype.$generalMethod = generalMethod;
Vue.prototype.$Storage = Storage;
Vue.prototype.$Ciphertext = Ciphertext;
Vue.prototype.$SyModel = SyModel;
Vue.use(Toast);
Vue.use(Base);
Vue.use(Report);
Vue.use(generalMethod);
Vue.use(Storage);
Vue.use(Ciphertext);
Vue.use(SyModel);
Vue.use(VueI18n);
const navLang = navigator.language || navigator.userLanguage;
let localLang = "en-US"; //本地开发语言包
let lang = navLang || "en-US"; //实际语言包
let urlData = Base.parseUrl(window.location.href);
const i18n = new VueI18n({
  locale: lang ? lang : localLang, // 语言标识，
  messages: {
    "en-US": require("./../../config/languages/en-US"),
    "zh-Hant": require("./../../config/languages/zh-Hant"),
    "th-TH": require("./../../config/languages/th-TH"),
    "id-ID": require("./../../config/languages/id-ID"),
    "vi-VN": require("./../../config/languages/vi-VN"),
  },
});
new Vue({
  i18n,
  render: (h) => h(Tpl),
  created() {
    if (lang.substring(0, 2) == "zh") {
      i18n.locale = "zh-Hant";
    } else if (lang.substring(0, 2) == "th") {
      i18n.locale = "th-TH";
    } else if (lang.substring(0, 2) == "id") {
      i18n.locale = "id-ID";
    } else if (lang.substring(0, 2) == "vi") {
      i18n.locale = "vi-VN";
    } else {
      i18n.locale = "en-US";
    }
    // 强制显示
    if (urlData.appid == "104293") {
      i18n.locale = "vi-VN";
    }
    localStorage.setItem("lang", i18n.locale);
  },
}).$mount("#rastar");
